const form = {
  formId: "new-milestone-form",
  formField: {
    name: {
      name: "name",
      label: "اسم المرحلة",
      type: "text",
      errorMsg: "اسم المرحلة مطلوب.",
    },
    description: {
      name: "description",
      label: "الوصف",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
    startDate: {
      name: "startDate",
      label: "تاريخ البدء",
      type: "date",
      errorMsg: "تاريخ البدء مطلوب.",
    },
    endDate: {
      name: "endDate",
      label: "تاريخ الانتهاء",
      type: "date",
      errorMsg: "تاريخ الانتهاء مطلوب.",
    },
    progress: {
      name: "progress",
      label: "نسبة التقدم",
      type: "number",
      errorMsg: "نسبة التقدم مطلوبة.",
    },
    Status: {
      name: "Status",
      label: "الحالة",
      type: "number",
      errorMsg: "الحالة مطلوبة.",
    },
    projectId: {
      name: "projectId",
      label: "رقم المشروع",
      type: "text",
      errorMsg: "رقم المشروع مطلوب.",
    },
  },
};

export default form;
